// ABOUTME: Lists a study family's phenotypes and routes to the single-dataset Manhattan viewer.
// ABOUTME: The family comes from the route's `data.family`, so one page serves GWAS 1-6 and v3.
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IDatasets, StudyFamily } from '../../interfaces/i-datasets';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { navFor } from '../../study-families';

@Component({
  selector: 'app-dataset-selection',
  templateUrl: './dataset-selection.component.html',
  styleUrl: './dataset-selection.component.scss',
})
export class DatasetSelectionComponent implements OnInit {
  /** Bound from the route's `data.family` via bindToComponentInputs. */
  @Input() family: StudyFamily = 'gwas16';

  public datasets: IDatasets[] = [];
  public error: HttpErrorResponse | undefined;

  constructor(
    private api: ApiService,
    private router: Router,
    public spinner: NgxSpinnerService
  ) {}

  get label(): string {
    return navFor(this.family).label;
  }

  get datasetsNotice(): string | undefined {
    return navFor(this.family).datasetsNotice;
  }

  private get baseRoute(): string {
    return navFor(this.family).baseRoute;
  }

  ngOnInit(): void {
    this.loadDatasets();
  }

  loadDatasets(): void {
    this.spinner.show();
    // Filter by study family, not reference genome: GWAS 1-6 and v3 are both GRCh38, so genome
    // alone would mix the two studies together.
    this.api.getDatasetsByFamily(this.family).subscribe({
      next: (result) => {
        this.datasets = result;
        this.spinner.hide();
      },
      error: (err: HttpErrorResponse) => {
        this.error = err;
        this.spinner.hide();
        // Fall back to this family's tool hub, not the homepage.
        setTimeout(() => {
          this.router.navigate([this.baseRoute]);
        }, 3000);
      },
    });
  }

  selectDataset(datasetName: string): void {
    this.router.navigate([`${this.baseRoute}/display`, datasetName]);
  }

  goBack(): void {
    this.router.navigate([this.baseRoute]);
  }
}
